// utils/handleApiError.js
import { toUserFriendlyMessage as mapToUserFriendlyMessage } from "./userFriendlyErrors";

export const toUserFriendlyMessage = (message) =>
  mapToUserFriendlyMessage(message);

export const handleApiError = (error, response = null, apiMessage = null) => {
  // When API returns a message, convert it to user-friendly wording first
  if (apiMessage && typeof apiMessage === "string") {
    const friendly = toUserFriendlyMessage(apiMessage);
    if (friendly) return friendly;
  }

  if (error?.name === "AbortError") {
    console.error("Request timed out.");
    return "The request took too long. Please try again.";
  }

  if (error?.message === "Failed to fetch") {
    console.error("Network error: Unable to reach the server.");
    return "Unable to connect. Please check your internet connection and try again.";
  }

  if (response && !response.ok) {
    switch (response.status) {
      case 400:
        return "Please check your input and try again.";
      case 401:
        return "Your session has expired. Please sign in again.";
      case 403:
        return "You don't have permission to perform this action.";
      case 404:
        return "The item you're looking for could not be found.";
      case 500:
        return "Something went wrong on our end. Please try again later.";
      case 503:
        return "Service is temporarily unavailable. Please try again in a few moments.";
      default:
        return "Something went wrong. Please try again.";
    }
  }

  console.error("Unexpected error:", error?.message || error);
  return "Something went wrong. Please try again.";
};
